export default {
    'Features': '产品介绍',
    'Solutions': '功能特点',
    'Contact': '联络方式',
    'Partner': '合作伙伴',
    'Download': '下载专区',
    'FAQ': '常见问题',
    'Freetrial': '申请试用',
    'locale.en': '英文',
    'locale.zh-TW': '繁体中文',
    'locale.zh-CN': '简体中文'
}